import { type ReactNode } from "react";
import { defaultShouldDehydrateQuery } from "@tanstack/react-query";
import { PersistQueryClientProvider } from "@tanstack/react-query-persist-client";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { queryClient, queryPersister } from "./query-client";
import { Toaster } from "sonner";

interface AppProvidersProps {
  children: ReactNode;
}

// Client state (Zustand stores in src/store/) needs no provider — only
// TanStack Query's persist provider wraps the tree.
export function AppProviders({ children }: AppProvidersProps) {
  return (
    <PersistQueryClientProvider
      client={queryClient}
      persistOptions={{
        persister: queryPersister,
        dehydrateOptions: {
          shouldDehydrateQuery: (query) =>
            !query.meta?.private &&
            !["webchat", "mission-editor"].includes(
              String(query.queryKey[0]),
            ) &&
            defaultShouldDehydrateQuery(query),
        },
      }}
    >
      {children}
      <Toaster position="top-right" richColors closeButton duration={4000} />
      {import.meta.env.DEV && <ReactQueryDevtools initialIsOpen={false} />}
    </PersistQueryClientProvider>
  );
}
